module.exports = __webpack_public_path__ + "img/changes_woman.ee22a089.svg";